"use strict";
var Observable_1 = require('../../Observable');
var catch_1 = require('../../operator/catch');
Observable_1.Observable.prototype.catch = catch_1._catch;
Observable_1.Observable.prototype._catch = catch_1._catch;
//# sourceMappingURL=catch.js.map


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/rxjs/add/operator/catch.js
 ** module id = 157
 ** module chunks = 2
 **/